<template>
    <div class="log_in">
        <div :class="`log_in_wrapper log_in_wrapper_media ${$store.state.sendConfirmCode ? 'd-none' : ''}`">
            <div>
                <router-link class="mobile_link" :to="{name: 'Register'}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M15 18L9 12L15 6" stroke="#C7FF24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>{{text('wallet.auth.login.register_link')}}</span>
                </router-link>
                <div class="title">{{text('wallet.auth.login.login')}}</div>
                <input-mask v-model:phone="phone" />
                <div class="text">
                    {{text('wallet.auth.login.sms_help')}}
                </div>                
            </div>
            <Button @btnClick="sendCode" :title="text('wallet.auth.login.send_code')"/>
            <br />
            <div class="error">{{ errorMessage }}</div>            
            <br />
            <div class="text">            
                <a href="/auth/register">{{text('wallet.auth.login.new_help')}}</a>
            </div>                
        </div>

        <!-- Identifiction -->
        <div :class="`identifiction ${!$store.state.sendConfirmCode ? 'd-none' : ''}`">
            <AuthIdentification 
                v-model:confirmCode="confirmCode" 
                :phone="phone" 
                @onPrevPage="changeToPrevPage"
                :title="text('wallet.auth.login.enter_code')" 
                :description="text('wallet.auth.login.enter_code_descr')"
            />
            <div class="identifiction_error">{{ errorMessage }}</div>
            <Button @btnClick="authLogin" :disabled="confirmCode.length < 4" :title="text('wallet.auth.login.enter_btn')"/>

            <div style="margin: 0 24px;" class="text" v-if="envName === 'stater'"> 
                <br />
                <br />
                Не приходит код? <br />
                Обратитесь в службу поддержки: <br /><br />
                <b>+7 (940) 999-11-33</b>    
                <br /> 
            </div>


            <send-again-button @btnClick="sendCode" :title="text('wallet.auth.login.sms_repeat')"/>
        </div>
        <!-- End identifiction -->
         
    </div>
</template>

<script>
import InputMask from '@/components/phone_input/InputMask.vue'
import Button from '@/components/Button.vue'
import ConfirmationInput from '@/components/ConfirmationInput.vue'
import AuthIdentification from '@/components/AuthIdentification.vue'
import SendAgainButton from '@/components/SendAgainButton.vue'
import GrokPolicy from '../components/GrokPolicy.vue'

export default {
    name: "LogIn",
    components: {
        InputMask,
        Button,
        ConfirmationInput,
        AuthIdentification,
        SendAgainButton,
        GrokPolicy,
    },
    mounted () {
        this.errorMessage = ''
    },
    data () {
        return {
            phone: '',
            confirmCode: '',
            errorMessage: '',
        }
    },
    methods: {
        async sendCode() {
            const { data } = await this.$http.post(
                '/v2/wallet/auth/send_code',
                { "phone": this.phone },
                {
                    validateStatus: (status) => (status >= 200 && status < 500)
                }
            );
            if (data.status === "error") {
                this.errorMessage = data.message
            } else {
                this.errorMessage = ''
                this.$store.commit('ConfirmCode');                
            }
        },
        async authLogin () {
            const { data } = await this.$http.post(
                '/v2/wallet/auth/login',
                { "phone": this.phone, "confirm_code": this.confirmCode },
                {
                    validateStatus: () => true
                }
            )

            if (data.status === "error") {
                this.errorMessage = data.message
            } else {
                this.errorMessage = ''
                this.$store.commit('setAuthToken', data.auth_token)
                this.$router.push('/')
            }
        },
        changeToPrevPage () {
            this.$store.commit('ConfirmCode')
        },
    }
}
</script>

<style>

</style>